import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ForgotPasswordPage() {
  const navigate          = useNavigate();
  const [login,     setLogin]     = useState('');
  const [sent,      setSent]      = useState(false);
  const [loading,   setLoading]   = useState(false);
  const [error,     setError]     = useState('');

  const handleSubmit = async () => {
    if (!login.trim()) { setError('Please enter your username or email.'); return; }
    setLoading(true);
    setError('');
    try {
      // Call WordPress lost password endpoint
      const formData = new FormData();
      formData.append('user_login', login);
      formData.append('redirect_to', '');
      formData.append('wp-submit', 'Get New Password');

      const res = await fetch('https://goprojectflow.com/wp-login.php?action=lostpassword', {
        method: 'POST',
        body:   formData,
        redirect: 'manual',
      });

      // WordPress redirects on success — any response means it worked
      setSent(true);
    } catch(e) {
      setSent(true); // Show success anyway to prevent user enumeration
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <span style={{ color: '#2563eb' }}>Go</span>
          <span style={{ color: '#0f172a' }}>Project</span>
          <span style={{ color: '#fb923c' }}>Flow</span>
        </div>

        {!sent ? (
          <>
            <h2 style={styles.title}>Reset your password</h2>
            <p style={styles.sub}>Enter your username or email and we'll send you a reset link.</p>

            {error && <p style={styles.error}>{error}</p>}

            <label style={styles.label}>Username or Email</label>
            <input
              style={styles.input}
              type="text"
              placeholder="Enter your username or email"
              value={login}
              onChange={e => setLogin(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSubmit()}
              autoFocus
            />

            <button style={styles.btn} onClick={handleSubmit} disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <button style={styles.backBtn} onClick={() => navigate('/login')}>
              ← Back to Login
            </button>
          </>
        ) : (
          <>
            <div style={styles.successIcon}>✉️</div>
            <h2 style={styles.title}>Check your email</h2>
            <p style={styles.sub}>If an account exists for <strong>{login}</strong>, you'll receive a password reset link shortly.</p>
            <button style={styles.btn} onClick={() => navigate('/login')}>
              Back to Login
            </button>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  wrapper:     { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f1f5f9', padding: 16 },
  card:        { background: 'white', borderRadius: 16, padding: '40px 36px', width: '100%', maxWidth: 420, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', textAlign: 'center' },
  logo:        { fontSize: 26, fontWeight: 800, letterSpacing: '-0.5px', marginBottom: 24 },
  title:       { fontSize: 20, fontWeight: 700, color: '#0f172a', margin: '0 0 8px' },
  sub:         { fontSize: 14, color: '#64748b', marginBottom: 24, lineHeight: 1.6 },
  label:       { display: 'block', textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 },
  input:       { width: '100%', padding: '11px 14px', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box', marginBottom: 16 },
  btn:         { width: '100%', padding: 13, background: '#2563eb', color: 'white', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: 'pointer', marginBottom: 12 },
  backBtn:     { background: 'none', border: 'none', color: '#64748b', fontSize: 14, cursor: 'pointer', padding: 0 },
  error:       { color: '#dc2626', fontSize: 13, marginBottom: 12 },
  successIcon: { fontSize: 48, marginBottom: 16 },
};